// extracted by mini-css-extract-plugin
module.exports = {"stack":"ProvidersLeading_stack__jfXuh","circle":"ProvidersLeading_circle__dw7hI","image":"ProvidersLeading_image__O_4HC"};